import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import "./whychoose.css";

const cards = [
  {
    title: "No Cancellation Fees",
    text: "Life happens — and schedules change. We stay flexible with no cancellation fees, ever.",
  },
  {
    title: "No Weekend or Holiday Charges",
    text: "Your routine shouldn’t cost more just because it’s a Saturday or Christmas. Our rates stay the same every day of the year.",
  },
  {
    title: "Free Meet & Greet",
    text: "Every family and pup is different. We offer a free meet & greet, and we’re always happy to do more than one if you or your pup need extra time to feel comfortable.",
  },
  {
    title: "Trust & Comfort First",
    text: "Inviting someone into your home is personal. We take that seriously — showing up with empathy, respect, and open communication from day one.",
  },
  {
    title: "Free Pick Up & Drop Off",
    text: "Free pick up & drop off included the boarding.",
  },
];

export default function WhyChooseUs() {
  const [openIndex, setOpenIndex] = useState(0);
  const refs = useRef([]);

  useEffect(() => {
    const observers = refs.current.map((el, index) => {
      if (!el) return null;

      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setOpenIndex(index);
        },
        {
          threshold: 0.01,
          rootMargin: "0px 0px -50% 0px",
        }
      );

      obs.observe(el);
      return obs;
    });

    return () => observers.forEach((o) => o && o.disconnect());
  }, []);

  return (
    <div className="why-wrapper">
      <h2 className="why-title">Why Choose Us</h2>
      {cards.map((c, i) => (
        <CardMobile
          key={i}
          title={c.title}
          text={c.text}
          isOpen={openIndex === i}
          innerRef={(el) => (refs.current[i] = el)}
        />
      ))}
    </div>
  );
}

function CardMobile({ title, text, isOpen, innerRef }) {
  return (
    <motion.div
      ref={innerRef}
      initial={{ opacity: 0, y: 40 }}
      animate={isOpen ? { opacity: 1, y: 0 } : { opacity: 0.3, y: 20 }}
      transition={{ duration: 0.4 }}
      className={`why-card ${isOpen ? "open" : "closed"}`}
    >
      <h3 className="why-card-title">{title}</h3>

      <motion.div
        initial={false}
        animate={{
          opacity: isOpen ? 1 : 0,
          height: isOpen ? "auto" : 0,
        }}
        transition={{ duration: 0.3 }}
        className="why-card-text"
      >
        <p>{text}</p>
      </motion.div>
    </motion.div>
  );
}
